/**
 * SaveButton component that allows users to save/bookmark events and places
 */
export default function SaveButton({ item, isSaved, onToggle, variant = 'default' }) {
    const handleClick = e => {
        e.preventDefault()
        e.stopPropagation()
        // Guard against undefined or null item - but allow the hook to handle it
        if (!item || !item.id) {
            console.error('SaveButton: Cannot toggle save for invalid item:', item)
            return
        }
        // Pass the full item object to the toggle handler
        onToggle(item)
    }

    const baseClasses =
        'flex items-center gap-1 rounded-lg transition focus:outline-none focus:ring-2 focus:ring-logo-pink focus:ring-offset-2'

    const variantClasses = {
        default: `px-3 py-2 text-sm font-medium ${
            isSaved
                ? 'bg-logo-pink text-white hover:bg-pink-600'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
        }`,
        icon: `p-2 ${
            isSaved ? 'text-logo-pink hover:text-pink-600' : 'text-gray-400 hover:text-gray-600'
        }`,
        compact: `px-2 py-1 text-xs ${
            isSaved
                ? 'bg-logo-pink text-white hover:bg-pink-600'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
        }`,
        'hover-circle': `p-2.5 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 shadow-lg ${
            isSaved ? 'text-logo-pink' : 'text-white'
        }`,
    }

    return (
        <button
            onClick={handleClick}
            className={`${baseClasses} ${variantClasses[variant]}`}
            aria-label={isSaved ? 'Remove from saved items' : 'Save for later'}
            title={isSaved ? 'Remove from saved items' : 'Save for later'}
        >
            {isSaved ? (
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                    <path
                        fillRule="evenodd"
                        d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                        clipRule="evenodd"
                    />
                </svg>
            ) : (
                <svg
                    className="h-5 w-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                </svg>
            )}
            {variant === 'default' && <span>{isSaved ? 'Saved' : 'Save'}</span>}
        </button>
    )
}
